import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useRetrieveResourceProjects } from "@planzone/view-models";
import { retrieveResourceProjectsQuery } from "@planzone/dto";
import { Flag, InfiniteScroll } from "@common/infiniteScroll";

import { FolderIcon } from "@common/folderIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Projects({ resource, redirect }: Props) {
  const { t } = useTranslation();
  const query = { ...retrieveResourceProjectsQuery, limit: 20 };
  const {
    isRequestPending,
    projects,
    canRetrieveNextResourceProjects,
    cursor,
    retrieveResourceProjects,
  } = useRetrieveResourceProjects(resource, query);

  return (
    <div className={styles.projects}>
      <h3 className={styles.header}>{t("editResource.projects")}</h3>
      <div className={styles.main}>
        <InfiniteScroll canFetchOnIdle>
          {() => (
            <ul className={styles.list}>
              {projects.map((project) => (
                <li key={project.uuid} onClick={redirect}>
                  <Link
                    className={styles.project}
                    to={`/projects/${project.uuid}`}
                  >
                    <FolderIcon className={styles.icon} />
                    <p className={styles.name}>{project.name}</p>
                  </Link>
                </li>
              ))}
              <Flag
                name="flag"
                isDisabled={
                  isRequestPending || !canRetrieveNextResourceProjects
                }
                retrieveItems={() =>
                  !isRequestPending &&
                  canRetrieveNextResourceProjects &&
                  retrieveResourceProjects({
                    resource,
                    query: { ...query, start: cursor },
                  })
                }
              />
            </ul>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
}

export { Projects };
